// extracted by mini-css-extract-plugin
export default {"wrapper":"Ir","subscription":"Jr","select_item":"Kr","is_selected":"Lr","otb":"Mr","radio":"Nr","first_row":"Or","prices":"Pr","italic":"Qr","info_wrapper":"Rr","first_month":"Sr","separator":"Tr","checkmark":"Ur","bullets":"Vr","bullet":"Wr","checkmarkText":"Xr","button":"Yr","discountBadge":"Zr"};
    if(module.hot) {
      // 1730991502395
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  